// Oduho - Outil "Règles ou Grossesse ?" (wizard 3 étapes)
(function () {
  var root = document.querySelector('.oduho-tool');
  if (!root || root.dataset.ready === 'true') return;
  root.dataset.ready = 'true';

  console.log('🧭 Outil règles/grossesse détecté');

  var stepEls = root.querySelectorAll('.oduho-step');
  var current = 0;
  var progressWrap = root.querySelector('[data-role="progress-wrap"]');
  var progressBar = root.querySelector('[data-role="progress-bar"]');
  var stepLabel = root.querySelector('[data-role="step-label"]');
  var stepPct = root.querySelector('[data-role="step-pct"]');
  var prevBtn = root.querySelector('[data-role="prev-button"]');
  var nextBtn = root.querySelector('[data-role="next-button"]');
  var resetBtn = root.querySelector('[data-role="reset-button"]');
  var resultBox = root.querySelector('.oduho-step[data-step="3"]');

  function selectedRadio(name) {
    var item = root.querySelector('input[name="' + name + '"]:checked');
    return item ? item.value : '';
  }
  function checked(key) {
    var item = root.querySelector('[data-oduho="' + key + '"]');
    return !!(item && item.checked);
  }
  function stepIsValid(i) {
    if (i === 0) return !!selectedRadio('oduho_timing');
    if (i === 1) return !!selectedRadio('oduho_risk');
    return true;
  }
  function updateNextState() {
    var ok = stepIsValid(current);
    nextBtn.style.opacity = ok ? '1' : '0.5';
    nextBtn.style.pointerEvents = ok ? 'auto' : 'none';
  }

  function render() {
    stepEls.forEach(function (el) {
      el.style.display = (parseInt(el.dataset.step, 10) === current) ? 'block' : 'none';
    });
    if (current < 3) {
      progressWrap.style.display = 'block';
      var pct = Math.round(((current + 1) / 3) * 100);
      progressBar.style.width = pct + '%';
      stepLabel.textContent = 'Question ' + (current + 1) + ' sur 3';
      stepPct.textContent = pct + '%';
      prevBtn.style.display = current > 0 ? 'inline-block' : 'none';
      nextBtn.style.display = 'inline-block';
      nextBtn.textContent = current === 2 ? 'Voir mon orientation →' : 'Suivant →';
      resetBtn.style.display = 'none';
      updateNextState();
    } else {
      progressWrap.style.display = 'none';
      prevBtn.style.display = 'none';
      nextBtn.style.display = 'none';
      resetBtn.style.display = 'inline-block';
      resultBox.scrollIntoView({behavior: 'smooth', block: 'nearest'});
    }
  }

  function computeResult() {
    var timing = selectedRadio('oduho_timing');
    var risk = selectedRadio('oduho_risk');
    var html = '';

    function card(title, text, action, tone) {
      var palette = {
        pink: {bg: '#fff5f8', border: '#c994b5', title: '#9d6b88'},
        green: {bg: '#f0f9f0', border: '#7db87d', title: '#5d7a5d'},
        orange: {bg: '#fff8f0', border: '#e8a05d', title: '#9a6638'},
        red: {bg: '#fff2f2', border: '#c95f5f', title: '#a64747'}
      };
      var c = palette[tone] || palette.pink;
      return '<div style="background:' + c.bg + '; padding:22px 24px; border-radius:12px; border-left:5px solid ' + c.border + ';">' +
        '<h3 style="color:' + c.title + '; margin:0 0 10px 0; font-size:1.25em;">' + title + '</h3>' +
        '<p style="line-height:1.7; color:#4a4a4a; margin:0 0 12px 0;">' + text + '</p>' +
        '<p style="line-height:1.7; color:#4a4a4a; margin:0;"><strong>Prochaine étape :</strong> ' + action + '</p>' +
      '</div>';
    }

    if (risk === 'none') {
      html = card(
        'Une grossesse ne semble pas possible d\'après votre réponse',
        'Vos symptômes peuvent correspondre au SPM, aux règles, ou à une autre cause non liée à une grossesse.',
        'Surveillez leur évolution. Consultez s\'ils sont inhabituels, intenses, persistants, ou accompagnés de fièvre, de pertes anormales ou de saignements importants.',
        'green'
      );
    } else if (timing === 'late' || checked('missed')) {
      var pregScore = (risk === 'yes' ? 3 : 0) + (checked('persistent') ? 3 : 0) + (checked('nausea') ? 2 : 0) + (checked('smell') ? 2 : 0);
      var perScore = checked('usual_bleeding') ? 5 : 0;
      html = card(
        pregScore >= perScore + 2 ? 'Une grossesse est possible, les symptômes ne suffisent pas à conclure' : 'Le retard de règles est l\'information la plus importante ici',
        'Votre profil contient un retard ou une absence de règles. Certains signes peuvent accompagner une grossesse, mais aussi le SPM, le stress ou une ovulation tardive.',
        'Faites un test de grossesse maintenant. S\'il est négatif et que les règles ne viennent toujours pas, répétez-le quelques jours plus tard.',
        'pink'
      );
    } else if (timing === 'unknown') {
      html = card(
        'Cycles irréguliers, les symptômes sont difficiles à interpréter',
        'Sans date de règles fiable, le retard ne peut pas servir de repère. Les symptômes communs ne permettent pas de départager le SPM et une grossesse.',
        (risk === 'yes' || risk === 'unknown') ? 'Faites un test au moins 21 jours après le dernier rapport pouvant entraîner une grossesse.' : 'Surveillez l\'évolution et consultez si vos cycles restent très irréguliers.',
        'orange'
      );
    } else if (timing === 'usual_period' && checked('usual_bleeding')) {
      html = card(
        'Votre profil ressemble davantage à vos règles habituelles',
        'Un flux comparable à vos menstruations habituelles oriente vers les règles ou le SPM plutôt que vers une grossesse.',
        (risk === 'yes' && checked('spotting')) ? 'Si le flux est finalement bien plus léger que d\'habitude, faites un test au bon moment.' : 'Observez si les symptômes diminuent dans les prochains jours. Consultez en cas de douleur ou de saignement inhabituel.',
        'green'
      );
    } else if (timing === 'soon') {
      html = card(
        'Trop tôt pour trancher avec les symptômes seuls',
        'Avant la date prévue des règles, les signes corporels se chevauchent presque complètement, même en cumulant plusieurs symptômes.',
        (risk === 'yes' || risk === 'unknown') ? 'Attendez le premier jour de retard pour tester, sauf avis médical différent.' : 'Observez si les symptômes disparaissent avec l\'arrivée des règles.',
        'orange'
      );
    } else {
      html = card(
        'Résultat indéterminé, et c\'est fréquent',
        'Vos réponses contiennent surtout des signes communs au SPM et au début d\'une grossesse, qu\'un questionnaire ne peut pas départager de façon fiable.',
        (risk === 'yes' || risk === 'unknown') ? 'Faites un test dès le premier jour de retard, ou 21 jours après le rapport à risque.' : 'Surveillez l\'évolution et demandez un avis médical si les symptômes persistent.',
        'pink'
      );
    }

    resultBox.innerHTML = html;
  }

  root.addEventListener('change', updateNextState);

  nextBtn.addEventListener('click', function () {
    if (!stepIsValid(current)) return;
    if (current === 2) { computeResult(); current = 3; render(); return; }
    current += 1;
    render();
  });

  prevBtn.addEventListener('click', function () {
    if (current > 0) { current -= 1; render(); }
  });

  resetBtn.addEventListener('click', function () {
    root.querySelectorAll('input').forEach(function (input) { input.checked = false; });
    current = 0;
    render();
  });

  render();

  console.log('✅ Outil règles/grossesse initialisé');
})();